import React from 'react'
import { intersection } from 'lodash'

import { Alert } from 'ui'

import { t } from 'translations'

function UserNoLongerVisibleAlert({ values, teamOptions, projectOptions }) {
  const managerProjects = projectOptions.filter(option => !option.isHidden).map(option => option.value)
  const managerTeams = teamOptions.filter(option => !option.isHidden).map(option => option.value)

  const isUserInOneOfManagerTeam = intersection(managerTeams, values.teams).length
  const isUserInOneOfManagerProject = intersection(managerProjects, values.projects).length

  return (
    <Alert variant="warning" show={!isUserInOneOfManagerTeam && !isUserInOneOfManagerProject}>
      {t(`manager.users.form.NO_OWN_PROJECT_OR_TEAM`)}
    </Alert>
  )
}

export default UserNoLongerVisibleAlert
